var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWishlistIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2295 11.8249C22.2295 17.4858 17.6404 22.0749 11.9795 22.0749C6.31857 22.0749 1.72949 17.4858 1.72949 11.8249C1.72949 9.27409 2.66033 6.94254 4.20181 5.14856C6.08276 2.95951 8.86903 1.57495 11.9795 1.57495C17.6404 1.57495 22.2295 6.16403 22.2295 11.8249Z",
    stroke: "#404554",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0102 7.51375C16.3819 6.88311 15.55 6.53842 14.6621 6.53842C13.7743 6.53842 12.9398 6.88566 12.3115 7.51631L11.9833 7.84567L11.65 7.5112C11.0217 6.88055 10.1847 6.53076 9.29686 6.53076C8.41155 6.53076 7.57713 6.878 6.95131 7.50609C6.32294 8.13674 5.97696 8.9742 5.97951 9.86528C5.97951 10.7564 6.32803 11.5913 6.9564 12.2219L11.734 17.0169C11.8001 17.0833 11.8892 17.119 11.9757 17.119C12.0622 17.119 12.1512 17.0858 12.2174 17.0194L17.0051 12.2321C17.6335 11.6015 17.9795 10.764 17.9795 9.87294C17.982 8.98186 17.6386 8.1444 17.0102 7.51375Z",
    fill: "#00B4D7",
    stroke: "#404554",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlistIcon);
export default __webpack_public_path__ + "static/media/wishlist-icon.646c7c88a420d32c76e5155de94d782b.svg";
export { ForwardRef as ReactComponent };